<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('mindfulMinutes.create.title')"
        )

        // Create form
        create-form(ref="form")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import Form from '../Form';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            Layout,
            CreateForm: Form,
            TitleComponent: Title,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapGetters('mindfulMinute', ['isLoading'])
        },
        methods: {
            ...mapActions('mindfulMinute', [ 'cancel']),

            /**
             * Create Business account on submit
             * @returns {boolean}
             */
            async submit() {
                this.$refs.form.submit();
            }
        }
    };
</script>
